import React, { useState, useEffect } from "react";
import MainLayout from "../layout/MainLayout";
import axios from "axios";
import { Link } from "react-router-dom";

function BlogPage() {
  const [posts, setBlogPosts] = useState([]);

  const getBlogPosts2 = async () => {
    axios
      .get("/api/v1/documents/metadatalist/0")
      .then((result) => setBlogPosts(result.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getBlogPosts2();
  }, []);

  return (
    <MainLayout>
      <h1>Posts</h1>
      {posts.map((post, index) => (
        <div key={index}>
          {index}.{" "}
          <Link to={"/Details/" + post.documentId + "/" + post.urlTitle}>
            {post.title}
          </Link>
          <hr />
        </div>
      ))}
    </MainLayout>
  );
}

export default BlogPage;
